import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApprovalDetailsDialogComponent } from './approval-details-dialog.component';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { ButtonModule } from '../../../../shared/button/button.module';
import { JumbotronModule } from '../../../../shared/jumbotron/jumbotron.module';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { LegfiCurrencyPipeModule } from '../../../../../pipes/format/legfi-currency.module';
import { LegfiDatePipeModule } from '../../../../../pipes/format/legfi-date.module';

@NgModule({
    declarations: [
        ApprovalDetailsDialogComponent
    ],
    imports: [
        CommonModule,
        MatDialogModule,
        ButtonModule,
        JumbotronModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatSortModule,
        MatTableModule,
        MatTooltipModule,
        LegfiCurrencyPipeModule,
        LegfiDatePipeModule,
    ],
})
export class ApprovalDetailsDialogModule { }
